import { useEffect, useState } from "react"
import { Formik, Field, Form, useFormikContext } from "formik"
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Summary,
    SummaryRow,
    SummaryLabel,
    SummaryValue,
    OptionText,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading,
    ModalLabel,
    RupeeIcon,
} from "../Styles/InputStyles"
import { toast } from "react-toastify"
import { FaCheckCircle, FaClock, FaMoneyBillWave, FaExclamationCircle } from "react-icons/fa"
import tw from "tailwind-styled-components"
import Config from "../../Config"
import { addDays, getDueIcon, getDueLabel, paymentModes } from "../../helpers"
import { FiEdit2 } from "react-icons/fi"
import { CircularProgress } from "@mui/material"
import Images from "../../Images"
import moment from "moment";
import { useSelector } from "react-redux"
import { MdEdit } from "react-icons/md"
import SelectOptionModal from "../SelectOptionModal"

const FormikContextUpdater = ({ paymentType, totalDue }) => {
    const { setFieldValue, values } = useFormikContext();

    useEffect(() => {
        if (paymentType === 2) {
            setFieldValue("amountPaid", totalDue);
        }
    }, [paymentType, totalDue, setFieldValue]);

    return null;
};

const InitialSettlement = ({
    onClose,
    InitialSettlementMutate,
    InitialSettlementLoading,
    dueListData,
    editDueLoading,
    editDueMutate,
    tenantId,
    roomId,
    propId,
    dueListLoading,
    route
}) => {
    const due = dueListData?.data?.data?.list || []
    const staffList = useSelector((state) => state.StaffListReducer.staffList);
    const staffListOptions = staffList
        ?.filter(type => type?.name && type?.id)
        .map(type => ({
            label: type.name,
            value: type.id,
        }));
    const getBookedByLabel = (typeValue) => {
        const type = staffListOptions?.find(option => option.value === typeValue);
        return type ? type.label : "Select Booked by...";
    };
    const ledgerReferenceId = due.length > 0 ? due[0].ledgerReferenceId : "0"
    const totalDue = dueListData?.data?.data?.totalDues
    const initialValues = {
        paymentType: 2,
        amountPaid: totalDue || "",
        paymentMode: "",
        notes: "",
        isOnlinePaymentEnabled: true,
        bookedBy: "",
    }
    const [isEditing, setIsEditing] = useState(false)
    const [editingIndex, setEditingIndex] = useState(null)
    const [editedValue, setEditedValue] = useState("")
    const [dueEditId, setDueEditId] = useState(null)
    const [isBookedByOpen, setIsBookedByOpen] = useState(false)

    const dues = due.map((item) => ({
        label: getDueLabel(item.type),
        amount: item.balance,
        rentStartDate: item.rentStartDate,
        rentEndDate: item.rentEndDate,
        icon: getDueIcon(item.type),
        id: item.id,
    }))

    const paymentTypes = [
        {
            value: 1,
            label: "No Dues",
            icon: <FaCheckCircle className="w-6 h-6 text-green-500" />,
        },
        {
            value: 2,
            label: "Pending Dues",
            icon: <FaClock className="w-6 h-6 text-yellow-500" />,
        },
        {
            value: 3,
            label: "Token Amount",
            icon: <FaMoneyBillWave className="w-6 h-6 text-blue-500" />,
        },
        {
            value: 4,
            label: "Excess Amount",
            icon: <FaExclamationCircle className="w-6 h-6 text-red-500" />,
        },
    ]
    // const paymentModes = [
    //     {
    //         value: 1,
    //         label: "Offline",
    //         icon: <img src={Images.Offline} alt="Offline" className="w-10 h-10" />,
    //     },
    //     {
    //         value: 2,
    //         label: "UPI",
    //         icon: <img src={Images.UPI} alt="UPI" className="w-10 h-10" />,
    //     },
    //     {
    //         value: 3,
    //         label: "Net Banking",
    //         icon: (
    //             <img src={Images.NetBanking} alt="Net Banking" className="w-10 h-10" />
    //         ),
    //     },
    //     {
    //         value: 4,
    //         label: "Card",
    //         icon: <img src={Images.Card} alt="Card" className="w-10 h-10" />,
    //     },
    // ];

    const handleSubmit = (values) => {
        const amountDepositRegex = /^\d{1,6}$/
        const maxAmountDeposit = 1000000

        if (!values.paymentType) {
            toast.error("Payment type is required")
            return
        }
        if (
            values.paymentType == 2 && Number(values.amountPaid) != Number(totalDue)
            && !values.paymentMode) {
            toast.error("Payment mode is required");
            return;
        }
        if (
            values.paymentType != 2
            && !values.paymentMode) {
            toast.error("Payment mode is required");
            return;
        }


        if (values.paymentType != 1) {
            const amountPaid = Number(values.amountPaid ?? 0);
            const dueAmount = Number(totalDue ?? 0);
            if (values.paymentType == 2 && amountPaid > dueAmount) {
                toast.error("Amount cannot be more than total dues");
                return;
            }

            if (values.paymentType == 2 && values.amountPaid == 0) {
            } else {

                if (values.amountPaid < 1) {
                    toast.error("Amount must be greater than 0")
                    return
                }
            }

            if (Number.parseInt(values.amountPaid) > maxAmountDeposit) {
                toast.error("Amount deposit cannot exceed 10,00,000")
                return
            }

            if (!amountDepositRegex.test(Number(values.amountPaid || totalDue))) {
                toast.error("Amount deposit must contain only numbers")
                return
            }
        }
        const payload = {
            propId: propId,
            roomId: roomId,
            tenantId,
            type: values.paymentType,
            amount: Number(values.amountPaid || totalDue),
            ledgerReferenceId,
            mode: values.paymentMode,
            notes: values.notes,
            bookedBy: values.bookedBy
        };
        if (
            dueListData?.data?.property?.isOnlinePaymentEnabled === Config.ONLINE_PAYMENT.ENABLED
        ) {
            payload.isonlinePayment = values.isOnlinePaymentEnabled ? 1 : 0;
        }

        InitialSettlementMutate(payload);

    }

    const handleEditClick = (dueId, amount, index) => {
        if (editingIndex === index) {
            setEditingIndex(null)
        } else {
            setEditingIndex(index)
            setEditedValue(amount)
            setDueEditId(dueId)
        }
    }

    const handleEditSubmit = () => {
        editDueMutate({
            dueId: dueEditId,
            newAmount: parseInt(editedValue),
            isTemp: false,
            tenantId: tenantId,
            isEvicted: false,
        });
        setEditingIndex(null);

    };

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            {({ values, setFieldValue }) => {
                const handleBookedBySelect = (selectedValue) => {
                    const selectedType = staffListOptions.find(type => type.value === selectedValue);
                    setFieldValue("bookedBy", selectedValue);
                };

                const currentBookedByLabel = getBookedByLabel(values.bookedBy);
                return (
                    <><Form>
                        <FormikContextUpdater paymentType={values.paymentType} totalDue={totalDue} />
                        <ModalSubHeading>{route === 'selectProperty' ? "Step 4" : "Step 3"}</ModalSubHeading>
                        <ModalHeading>Initial Settlement</ModalHeading>
                        {dueListLoading && (
                            <div className="flex justify-center items-center my-40">
                                <CircularProgress size={40} />
                            </div>
                        )}
                        <>
                            <ScrollableContent>
                                <Wrapper className="gap-4">
                                    {!dueListLoading && dueListData && (
                                        <>
                                            <InputGroup>
                                                <ModalLabel>Dues</ModalLabel>
                                                {totalDue === 0 ? (
                                                    <div className="text-gray-500 text-center text-sm">No Due Pending</div>
                                                ) : (
                                                    <> {dues.map((due, index) => (

                                                        <DuesItem key={due.id}>
                                                            <DuesLabel>
                                                                {due.icon}
                                                                <span>{due.label === 'Rent' ?
                                                                    due.label + ' : ' + moment(due?.rentStartDate || new Date()).format(
                                                                        'DD MMM YY'
                                                                    ) +
                                                                    ' - ' +
                                                                    moment(
                                                                        due?.rentEndDate || addDays(new Date(), 30)
                                                                    ).format('DD MMM YY')
                                                                    :
                                                                    due.label}</span>
                                                                <EditIcon onClick={() => handleEditClick(due.id, due.amount, index)}>
                                                                    <FiEdit2 size={12} />
                                                                </EditIcon>
                                                            </DuesLabel>
                                                            {editingIndex === index ? (
                                                                <div className="flex items-center space-x-2">
                                                                    <input
                                                                        type="number"
                                                                        value={editedValue}
                                                                        onChange={(e) => setEditedValue(e.target.value)}
                                                                        className="ml-2 p-1 w-24 border rounded" />

                                                                    <button
                                                                        type="button"
                                                                        onClick={handleEditSubmit}
                                                                        className="bg-white text-primary-color border border-primary-color px-2 py-1.5 rounded text-xs"
                                                                        disabled={!editedValue || editDueLoading}
                                                                    >
                                                                        {editDueLoading ? "Submitting..." : "Submit"}
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <Amount>₹{due.amount.toLocaleString()}</Amount>
                                                            )}
                                                        </DuesItem>
                                                    ))}
                                                        <TotalDues>
                                                            <span>Total dues</span>
                                                            <span>₹{totalDue}</span>
                                                        </TotalDues>
                                                    </>
                                                )}
                                            </InputGroup>

                                            <InputWrapper>
                                                <ModalLabel htmlFor="paymentType">Adjust Dues *</ModalLabel>
                                                <div className="grid grid-cols-4 gap-2">
                                                    {paymentTypes.map((option) => (
                                                        <OptionCard
                                                            key={option.value}
                                                            isSelected={values.paymentType === option.value}
                                                            onClick={() => {
                                                                setFieldValue("paymentType", option.value)
                                                                // setFieldValue("amountPaid", "");
                                                                if (option.value == 2) {
                                                                    setFieldValue("amountPaid", totalDue)
                                                                } else {
                                                                    setFieldValue("amountPaid", "")
                                                                }
                                                            }}
                                                        >
                                                            {/* {option.icon} */}
                                                            <OptionText className="mt-0">{option.label}</OptionText>
                                                        </OptionCard>
                                                    ))}
                                                </div>

                                                {values.paymentType !== 1 && (
                                                    <InputGroup>
                                                        <Label htmlFor="amountPaid">Amount *</Label>
                                                        <FieldWrappers className="w-full">
                                                            <RupeeIcon />
                                                            <Field
                                                                name="amountPaid"
                                                                type="number"
                                                                placeholder={values.paymentType === 2 ? `Enter Amount (Total Dues: ₹${totalDue})` : "Enter Amount"}
                                                                value={values.amountPaid}
                                                                // value={values.paymentType == 2 ? values.amountPaid || totalDue : values.amountPaid}
                                                                onFocus={() => setIsEditing(true)}
                                                                onChange={(e) => {
                                                                    setFieldValue("amountPaid", e.target.value)
                                                                }}
                                                                className="w-full pl-6" />
                                                        </FieldWrappers>
                                                    </InputGroup>
                                                )}
                                                <Label>Payment Mode *</Label>
                                                <PaymentModeWrapper>
                                                    {paymentModes.map((mode) => (
                                                        <PaymentModeCard
                                                            key={mode.value}
                                                            type="button"
                                                            onClick={(e) => {
                                                                e.preventDefault()
                                                                setFieldValue("paymentMode", mode.value, false)
                                                            }}
                                                            className={values.paymentMode === mode.value
                                                                ? "bg-blue-100 border-blue-500"
                                                                : "bg-gray-100"}
                                                        >
                                                            <span className="text-sm">{mode.label}</span>
                                                        </PaymentModeCard>
                                                    ))}
                                                </PaymentModeWrapper>
                                            </InputWrapper>
                                            {dueListData?.data?.property?.isOnlinePaymentEnabled === Config.ONLINE_PAYMENT.ENABLED &&
                                                <InputGroup>
                                                    <Label>Online Payment</Label>

                                                    <label className="flex items-center space-x-2">
                                                        <Field
                                                            type="checkbox"
                                                            name="isOnlinePaymentEnabled"
                                                            checked={values.isOnlinePaymentEnabled}
                                                            onChange={(e) => {
                                                                setFieldValue("isOnlinePaymentEnabled", e.target.checked)

                                                            }}
                                                            className="form-checkbox h-4 w-4 text-blue-600" />
                                                        <span className="text-sm text-gray-800">Is Online Payment Enabled?</span>
                                                    </label>
                                                </InputGroup>}
                                            <InputGroup>
                                                <Label htmlFor="notes">Notes (Visible Only to Owner)</Label>
                                                <FieldWrapper>
                                                    <Field
                                                        as={Textarea}
                                                        id="notes"
                                                        name="notes"
                                                        rows={4}
                                                        placeholder="Write remarks or reminders for future reference" />
                                                </FieldWrapper>
                                            </InputGroup>
                                        </>
                                    )}
                                    {/* {values.paymentType !== 2 && Number(values.amountPaid) !== Number(totalDue) && ( */}
                                    {/* <InputGroup>
        <Label>Payment Mode *</Label>
        <PaymentModeWrapper>
            {paymentModes.map((mode) => (
                <PaymentModeCard
                    key={mode.value}
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        setFieldValue("paymentMode", mode.value, false);
                    }}
                    className={
                        values.paymentMode === mode.value
                            ? "bg-blue-100 border-blue-500"
                            : "bg-gray-100"
                    }
                >
                    <span className="text-sm">{mode.label}</span>
                </PaymentModeCard>
            ))}
        </PaymentModeWrapper>
    </InputGroup> */}
                                    {/* )} */}

                                    {/* <InputGroup>
        <ModalLabel htmlFor="isOnlinePaymentEnabled">Online Payment</ModalLabel>
        <div className="gap-2">
            <label className="flex items-center space-x-2">
                <Field
                    type="checkbox"
                    name="isOnlinePaymentEnabled"
                    checked={values.isOnlinePaymentEnabled}
                    onChange={(e) => {
                        setFieldValue("isOnlinePaymentEnabled", e.target.checked);
                    }}
                    className="form-checkbox h-4 w-4 text-blue-600"
                />
                <span className="text-sm text-gray-600">Allow tenant to make online payment.</span>
            </label>
        </div>
    </InputGroup> */}

                                    <Summary>
                                        <ModalLabel>Dues Summary</ModalLabel>
                                        <SummaryRow>
                                            <SummaryLabel>Total Dues</SummaryLabel>
                                            <SummaryValue>₹{totalDue || 0}</SummaryValue>
                                        </SummaryRow>
                                        <SummaryRow>
                                            <SummaryLabel>Adjusted Dues</SummaryLabel>
                                            <SummaryValue>
                                                {values.paymentType === 1
                                                    ? `₹${totalDue}`
                                                    : values.paymentType === 2
                                                        ? `₹${Number(totalDue) - Number(values.amountPaid || totalDue)}`
                                                        : values.paymentType === 3
                                                            ? `₹${values.amountPaid || 0}`
                                                            : values.paymentType === 4
                                                                ? `₹${Number(totalDue) + Number(values.amountPaid)}`
                                                                : "₹0"}
                                            </SummaryValue>
                                        </SummaryRow>
                                        <SummaryRow className="border-dotted border-t border-b border-gray-400 py-2 mt-2">
                                            <SummaryLabel>Remaining Dues</SummaryLabel>
                                            <SummaryValue>
                                                {values.paymentType === 1
                                                    ? `₹0`
                                                    : values.paymentType === 2
                                                        ? `₹${Number(values.amountPaid || totalDue)}`
                                                        : values.paymentType === 3
                                                            ? `${totalDue - (Number(values.amountPaid) || 0) < 0 ? "-" : ""}₹${Math.abs(
                                                                totalDue - (Number(values.amountPaid) || 0)
                                                            )}`
                                                            : values.paymentType === 4
                                                                ? `${totalDue - (Number(totalDue) + Number(values.amountPaid)) < 0 ? "-" : ""}₹${Math.abs(
                                                                    totalDue - (Number(totalDue) + Number(values.amountPaid))
                                                                )}`
                                                                : `₹${totalDue}`}
                                            </SummaryValue>
                                        </SummaryRow>
                                    </Summary>
                                    <InputGroup>
                                        <Label htmlFor="bookedBy">Booked by</Label>
                                        <FieldWrappers onClick={() => setIsBookedByOpen(true)}>

                                            <Field
                                                type="text"
                                                name="typeDisplay"
                                                id="typeDisplay"
                                                autoComplete="off"
                                                readOnly
                                                value={currentBookedByLabel}
                                                className="w-full border-none outline-none bg-transparent cursor-pointer" />
                                            <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />

                                        </FieldWrappers>

                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={onClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={InitialSettlementLoading}>
                                    {InitialSettlementLoading ? "Submitting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                        </>
                    </Form><SelectOptionModal
                            isOpen={isBookedByOpen}
                            onClose={() => setIsBookedByOpen(false)}
                            title="Select Vendor Type"
                            options={staffListOptions}
                            selectedValue={values.bookedBy}
                            onSelect={handleBookedBySelect}
                            searchPlaceholder="Search vendor types..." /></>
                )
            }}
        </Formik>
    )
}

const InputWrapper = tw.div`w-full flex flex-col md:space-y-1.5 space-y-1 mt-2 md:mt-0`;
const FieldWrapper = tw.div`w-full`;
const OptionCard = tw.div`
  flex flex-col items-center justify-center py-2 px-2 rounded-lg shadow border border-gray-200 text-center
  cursor-pointer transition-all duration-200 
  ${(props) => (props.isSelected ? "bg-primary-color/10 border-primary-color" : "bg-white hover:bg-gray-50")}
`
const Textarea = tw.textarea`min-h-30 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-30 resize-y  break-words overflow-hidden`;
const DuesItem = tw.div`flex justify-between items-center py-1 border-b last:border-b-0`
const DuesLabel = tw.div`flex items-center space-x-2 text-sm text-gray-600`
const EditIcon = tw.span`text-gray-400 cursor-pointer text-sm hover:text-gray-600`
const Amount = tw.div`text-gray-800 font-medium text-base`
const TotalDues = tw.div`flex justify-between items-center text-base font-medium border-b text-gray-800 pt-1 pb-2`
const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`;
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`;
export default InitialSettlement
